import type { IsoDate, IsoDateTime } from '../ids.js';

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const nowIso = (): IsoDateTime => new Date().toISOString();

export const toIsoDate = (value: Date | string): IsoDate =>
  (typeof value === 'string' ? new Date(value) : value).toISOString().slice(0, 10);

/** Whole days between two instants. Negative when `to` is in the past. */
export function daysBetween(from: Date | string, to: Date | string): number {
  const a = typeof from === 'string' ? new Date(from) : from;
  const b = typeof to === 'string' ? new Date(to) : to;
  return Math.round((b.getTime() - a.getTime()) / MS_PER_DAY);
}

export function addDays(value: Date | string, days: number): Date {
  const base = typeof value === 'string' ? new Date(value) : new Date(value.getTime());
  base.setUTCDate(base.getUTCDate() + days);
  return base;
}

export function isPast(value: IsoDateTime | IsoDate, reference: Date = new Date()): boolean {
  return new Date(value).getTime() < reference.getTime();
}
